module.exports = __webpack_public_path__ + "img/06_food2.7cecabe8.png";